export const COUNTRY_PHONE_OPTIONS = [
  { iso: "IN", country: "India", dial: "+91" },
  { iso: "US", country: "United States", dial: "+1" },
  { iso: "CA", country: "Canada", dial: "+1" },
  { iso: "GB", country: "United Kingdom", dial: "+44" },
  { iso: "AU", country: "Australia", dial: "+61" },
  { iso: "NZ", country: "New Zealand", dial: "+64" },
  { iso: "AE", country: "United Arab Emirates", dial: "+971" },
  { iso: "SA", country: "Saudi Arabia", dial: "+966" },
  { iso: "QA", country: "Qatar", dial: "+974" },
  { iso: "KW", country: "Kuwait", dial: "+965" },
  { iso: "OM", country: "Oman", dial: "+968" },
  { iso: "BH", country: "Bahrain", dial: "+973" },
  { iso: "SG", country: "Singapore", dial: "+65" },
  { iso: "MY", country: "Malaysia", dial: "+60" },
  { iso: "ID", country: "Indonesia", dial: "+62" },
  { iso: "TH", country: "Thailand", dial: "+66" },
  { iso: "VN", country: "Vietnam", dial: "+84" },
  { iso: "PH", country: "Philippines", dial: "+63" },
  { iso: "BD", country: "Bangladesh", dial: "+880" },
  { iso: "PK", country: "Pakistan", dial: "+92" },
  { iso: "LK", country: "Sri Lanka", dial: "+94" },
  { iso: "NP", country: "Nepal", dial: "+977" },
  { iso: "BT", country: "Bhutan", dial: "+975" },
  { iso: "MM", country: "Myanmar", dial: "+95" },
  { iso: "CN", country: "China", dial: "+86" },
  { iso: "JP", country: "Japan", dial: "+81" },
  { iso: "KR", country: "South Korea", dial: "+82" },
  { iso: "TW", country: "Taiwan", dial: "+886" },
  { iso: "HK", country: "Hong Kong", dial: "+852" },
  { iso: "MO", country: "Macau", dial: "+853" },
  { iso: "AF", country: "Afghanistan", dial: "+93" },
  { iso: "AL", country: "Albania", dial: "+355" },
  { iso: "DZ", country: "Algeria", dial: "+213" },
  { iso: "AD", country: "Andorra", dial: "+376" },
  { iso: "AO", country: "Angola", dial: "+244" },
  { iso: "AG", country: "Antigua and Barbuda", dial: "+1-268" },
  { iso: "AR", country: "Argentina", dial: "+54" },
  { iso: "AM", country: "Armenia", dial: "+374" },
  { iso: "AT", country: "Austria", dial: "+43" },
  { iso: "AZ", country: "Azerbaijan", dial: "+994" },
  { iso: "BS", country: "Bahamas", dial: "+1-242" },
  { iso: "BB", country: "Barbados", dial: "+1-246" },
  { iso: "BY", country: "Belarus", dial: "+375" },
  { iso: "BE", country: "Belgium", dial: "+32" },
  { iso: "BZ", country: "Belize", dial: "+501" },
  { iso: "BJ", country: "Benin", dial: "+229" },
  { iso: "BO", country: "Bolivia", dial: "+591" },
  { iso: "BA", country: "Bosnia and Herzegovina", dial: "+387" },
  { iso: "BW", country: "Botswana", dial: "+267" },
  { iso: "BR", country: "Brazil", dial: "+55" },
  { iso: "BN", country: "Brunei", dial: "+673" },
  { iso: "BG", country: "Bulgaria", dial: "+359" },
  { iso: "BF", country: "Burkina Faso", dial: "+226" },
  { iso: "BI", country: "Burundi", dial: "+257" },
  { iso: "KH", country: "Cambodia", dial: "+855" },
  { iso: "CM", country: "Cameroon", dial: "+237" },
  { iso: "CV", country: "Cape Verde", dial: "+238" },
  { iso: "CF", country: "Central African Republic", dial: "+236" },
  { iso: "TD", country: "Chad", dial: "+235" },
  { iso: "CL", country: "Chile", dial: "+56" },
  { iso: "CO", country: "Colombia", dial: "+57" },
  { iso: "KM", country: "Comoros", dial: "+269" },
  { iso: "CG", country: "Congo - Brazzaville", dial: "+242" },
  { iso: "CD", country: "Congo - Kinshasa", dial: "+243" },
  { iso: "CR", country: "Costa Rica", dial: "+506" },
  { iso: "HR", country: "Croatia", dial: "+385" },
  { iso: "CU", country: "Cuba", dial: "+53" },
  { iso: "CY", country: "Cyprus", dial: "+357" },
  { iso: "CZ", country: "Czech Republic", dial: "+420" },
  { iso: "DK", country: "Denmark", dial: "+45" },
  { iso: "DJ", country: "Djibouti", dial: "+253" },
  { iso: "DM", country: "Dominica", dial: "+1-767" },
  { iso: "DO", country: "Dominican Republic", dial: "+1-809" },
  { iso: "EC", country: "Ecuador", dial: "+593" },
  { iso: "EG", country: "Egypt", dial: "+20" },
  { iso: "SV", country: "El Salvador", dial: "+503" },
  { iso: "GQ", country: "Equatorial Guinea", dial: "+240" },
  { iso: "ER", country: "Eritrea", dial: "+291" },
  { iso: "EE", country: "Estonia", dial: "+372" },
  { iso: "SZ", country: "Eswatini", dial: "+268" },
  { iso: "ET", country: "Ethiopia", dial: "+251" },
  { iso: "FJ", country: "Fiji", dial: "+679" },
  { iso: "FI", country: "Finland", dial: "+358" },
  { iso: "FR", country: "France", dial: "+33" },
  { iso: "GA", country: "Gabon", dial: "+241" },
  { iso: "GM", country: "Gambia", dial: "+220" },
  { iso: "GE", country: "Georgia", dial: "+995" },
  { iso: "DE", country: "Germany", dial: "+49" },
  { iso: "GH", country: "Ghana", dial: "+233" },
  { iso: "GR", country: "Greece", dial: "+30" },
  { iso: "GD", country: "Grenada", dial: "+1-473" },
  { iso: "GT", country: "Guatemala", dial: "+502" },
  { iso: "GN", country: "Guinea", dial: "+224" },
  { iso: "GW", country: "Guinea-Bissau", dial: "+245" },
  { iso: "GY", country: "Guyana", dial: "+592" },
  { iso: "HT", country: "Haiti", dial: "+509" },
  { iso: "HN", country: "Honduras", dial: "+504" },
  { iso: "HU", country: "Hungary", dial: "+36" },
  { iso: "IS", country: "Iceland", dial: "+354" },
  { iso: "IR", country: "Iran", dial: "+98" },
  { iso: "IQ", country: "Iraq", dial: "+964" },
  { iso: "IE", country: "Ireland", dial: "+353" },
  { iso: "IL", country: "Israel", dial: "+972" },
  { iso: "IT", country: "Italy", dial: "+39" },
  { iso: "JM", country: "Jamaica", dial: "+1-876" },
  { iso: "JO", country: "Jordan", dial: "+962" },
  { iso: "KZ", country: "Kazakhstan", dial: "+7" },
  { iso: "KE", country: "Kenya", dial: "+254" },
  { iso: "KI", country: "Kiribati", dial: "+686" },
  { iso: "XK", country: "Kosovo", dial: "+383" },
  { iso: "KG", country: "Kyrgyzstan", dial: "+996" },
  { iso: "LA", country: "Laos", dial: "+856" },
  { iso: "LV", country: "Latvia", dial: "+371" },
  { iso: "LB", country: "Lebanon", dial: "+961" },
  { iso: "LS", country: "Lesotho", dial: "+266" },
  { iso: "LR", country: "Liberia", dial: "+231" },
  { iso: "LY", country: "Libya", dial: "+218" },
  { iso: "LI", country: "Liechtenstein", dial: "+423" },
  { iso: "LT", country: "Lithuania", dial: "+370" },
  { iso: "LU", country: "Luxembourg", dial: "+352" },
  { iso: "MG", country: "Madagascar", dial: "+261" },
  { iso: "MW", country: "Malawi", dial: "+265" },
  { iso: "MV", country: "Maldives", dial: "+960" },
  { iso: "ML", country: "Mali", dial: "+223" },
  { iso: "MT", country: "Malta", dial: "+356" },
  { iso: "MH", country: "Marshall Islands", dial: "+692" },
  { iso: "MR", country: "Mauritania", dial: "+222" },
  { iso: "MU", country: "Mauritius", dial: "+230" },
  { iso: "MX", country: "Mexico", dial: "+52" },
  { iso: "FM", country: "Micronesia", dial: "+691" },
  { iso: "MD", country: "Moldova", dial: "+373" },
  { iso: "MC", country: "Monaco", dial: "+377" },
  { iso: "MN", country: "Mongolia", dial: "+976" },
  { iso: "ME", country: "Montenegro", dial: "+382" },
  { iso: "MA", country: "Morocco", dial: "+212" },
  { iso: "MZ", country: "Mozambique", dial: "+258" },
  { iso: "NA", country: "Namibia", dial: "+264" },
  { iso: "NR", country: "Nauru", dial: "+674" },
  { iso: "NL", country: "Netherlands", dial: "+31" },
  { iso: "NI", country: "Nicaragua", dial: "+505" },
  { iso: "NE", country: "Niger", dial: "+227" },
  { iso: "NG", country: "Nigeria", dial: "+234" },
  { iso: "KP", country: "North Korea", dial: "+850" },
  { iso: "MK", country: "North Macedonia", dial: "+389" },
  { iso: "NO", country: "Norway", dial: "+47" },
  { iso: "PA", country: "Panama", dial: "+507" },
  { iso: "PG", country: "Papua New Guinea", dial: "+675" },
  { iso: "PY", country: "Paraguay", dial: "+595" },
  { iso: "PE", country: "Peru", dial: "+51" },
  { iso: "PL", country: "Poland", dial: "+48" },
  { iso: "PT", country: "Portugal", dial: "+351" },
  { iso: "PR", country: "Puerto Rico", dial: "+1-787" },
  { iso: "RO", country: "Romania", dial: "+40" },
  { iso: "RU", country: "Russia", dial: "+7" },
  { iso: "RW", country: "Rwanda", dial: "+250" },
  { iso: "KN", country: "Saint Kitts and Nevis", dial: "+1-869" },
  { iso: "LC", country: "Saint Lucia", dial: "+1-758" },
  { iso: "VC", country: "Saint Vincent and the Grenadines", dial: "+1-784" },
  { iso: "WS", country: "Samoa", dial: "+685" },
  { iso: "SM", country: "San Marino", dial: "+378" },
  { iso: "ST", country: "Sao Tome and Principe", dial: "+239" },
  { iso: "SN", country: "Senegal", dial: "+221" },
  { iso: "RS", country: "Serbia", dial: "+381" },
  { iso: "SC", country: "Seychelles", dial: "+248" },
  { iso: "SL", country: "Sierra Leone", dial: "+232" },
  { iso: "SK", country: "Slovakia", dial: "+421" },
  { iso: "SI", country: "Slovenia", dial: "+386" },
  { iso: "SB", country: "Solomon Islands", dial: "+677" },
  { iso: "SO", country: "Somalia", dial: "+252" },
  { iso: "ZA", country: "South Africa", dial: "+27" },
  { iso: "SS", country: "South Sudan", dial: "+211" },
  { iso: "ES", country: "Spain", dial: "+34" },
  { iso: "SD", country: "Sudan", dial: "+249" },
  { iso: "SR", country: "Suriname", dial: "+597" },
  { iso: "SE", country: "Sweden", dial: "+46" },
  { iso: "CH", country: "Switzerland", dial: "+41" },
  { iso: "SY", country: "Syria", dial: "+963" },
  { iso: "TJ", country: "Tajikistan", dial: "+992" },
  { iso: "TZ", country: "Tanzania", dial: "+255" },
  { iso: "TL", country: "Timor-Leste", dial: "+670" },
  { iso: "TG", country: "Togo", dial: "+228" },
  { iso: "TO", country: "Tonga", dial: "+676" },
  { iso: "TT", country: "Trinidad and Tobago", dial: "+1-868" },
  { iso: "TN", country: "Tunisia", dial: "+216" },
  { iso: "TR", country: "Turkey", dial: "+90" },
  { iso: "TM", country: "Turkmenistan", dial: "+993" },
  { iso: "TV", country: "Tuvalu", dial: "+688" },
  { iso: "UG", country: "Uganda", dial: "+256" },
  { iso: "UA", country: "Ukraine", dial: "+380" },
  { iso: "UY", country: "Uruguay", dial: "+598" },
  { iso: "UZ", country: "Uzbekistan", dial: "+998" },
  { iso: "VU", country: "Vanuatu", dial: "+678" },
  { iso: "VA", country: "Vatican City", dial: "+379" },
  { iso: "VE", country: "Venezuela", dial: "+58" },
  { iso: "VN", country: "Vietnam", dial: "+84" },
  { iso: "YE", country: "Yemen", dial: "+967" },
  { iso: "ZM", country: "Zambia", dial: "+260" },
  { iso: "ZW", country: "Zimbabwe", dial: "+263" },
  { iso: "GI", country: "Gibraltar", dial: "+350" },
  { iso: "FO", country: "Faroe Islands", dial: "+298" },
  { iso: "GL", country: "Greenland", dial: "+299" },
  { iso: "BM", country: "Bermuda", dial: "+1-441" },
  { iso: "KY", country: "Cayman Islands", dial: "+1-345" },
  { iso: "AW", country: "Aruba", dial: "+297" },
  { iso: "CW", country: "Curacao", dial: "+599" },
  { iso: "GU", country: "Guam", dial: "+1-671" },
  { iso: "VI", country: "U.S. Virgin Islands", dial: "+1-340" },
  { iso: "AS", country: "American Samoa", dial: "+1-684" },
  { iso: "MP", country: "Northern Mariana Islands", dial: "+1-670" },
  { iso: "PF", country: "French Polynesia", dial: "+689" },
  { iso: "NC", country: "New Caledonia", dial: "+687" },
  { iso: "MQ", country: "Martinique", dial: "+596" },
  { iso: "GP", country: "Guadeloupe", dial: "+590" },
  { iso: "RE", country: "Reunion", dial: "+262" },
  { iso: "YT", country: "Mayotte", dial: "+262" },
  { iso: "BL", country: "Saint Barthelemy", dial: "+590" },
  { iso: "MF", country: "Saint Martin", dial: "+590" },
  { iso: "PM", country: "Saint Pierre and Miquelon", dial: "+508" },
  { iso: "WF", country: "Wallis and Futuna", dial: "+681" },
  { iso: "SH", country: "Saint Helena", dial: "+290" },
  { iso: "TC", country: "Turks and Caicos Islands", dial: "+1-649" },
  { iso: "VG", country: "British Virgin Islands", dial: "+1-284" },
  { iso: "FK", country: "Falkland Islands", dial: "+500" },
  { iso: "CC", country: "Cocos (Keeling) Islands", dial: "+61" },
  { iso: "CX", country: "Christmas Island", dial: "+61" },
  { iso: "NU", country: "Niue", dial: "+683" },
  { iso: "TK", country: "Tokelau", dial: "+690" },
];

export const INDIA_COUNTRY_OPTION = COUNTRY_PHONE_OPTIONS.find(
  (opt) => opt.iso === "IN",
);
